import e, { useCallback as t, isValidElement as a } from "react";
import { Menu as n, Avatar as l, Layout as r } from "antd";
import s from "classnames";
import "./index.scss.js";
import { MenuUnfoldOutlined as m, MenuFoldOutlined as i } from "@ant-design/icons";
var o = n.SubMenu;
export default (function (c) {
  var u = c.fixed,
      d = c.collapsed,
      E = c.username,
      p = c.title,
      g = c.avatar,
      f = c.onSignOut,
      y = c.onCollapseChange,
      k = t(function (e) {
    "SignOut" === e.key && f && f();
  }, [f]),
      h = e.createElement(n, {
    key: "user",
    mode: "horizontal",
    onClick: k
  }, e.createElement(o, {
    key: "user-sub-menu",
    title: e.createElement("div", {
      className: "user-sub-menu-title"
    }, e.createElement("span", {
      style: {
        color: "#999",
        marginRight: 4
      }
    }, "Hi,"), e.createElement("span", null, E), e.createElement(l, {
      size: "small",
      src: g,
      style: {
        marginLeft: 8
      }
    }))
  }, f && e.createElement(n.Item, {
    key: "SignOut"
  }, "Sign out")));
  return e.createElement(r.Header, {
    className: s("header", {
      fixed: u,
      collapsed: d
    }),
    id: "layoutHeader"
  }, e.createElement("div", {
    className: "button",
    onClick: function onClick() {
      return y && y(!d);
    }
  }, d ? e.createElement(m, null) : e.createElement(i, null)), a(p) && p, e.createElement("div", {
    className: "rightContainer"
  }, h));
});